import React from "react";
import styled from "styled-components";

export default styled.div`
    display: none;

    ${(props) => (props.open ? {
    'display': 'block'
} : '')}
`;